import React from 'react'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import Rootroute from './Components/Rootroute'
import About from './Components/About'
import Register from './Components/Register'
import Login from './Components/Login'
import HomePage from './Components/ChatApp/HomePage'
import ResetPass from './Components/ResetPass'
import Not_Authorize from './Components/Nopage/Not_Authorised'
import Charts from './Components/ChatApp/Charts'
import Error from './Components/Nopage/Error'
import Contact from './Components/Contact'

function App() {
    var date = new Date();
    date.setDate(date.getDate() + 3);
    return (
        <div>
            <BrowserRouter>
                <Routes>
                    <Route exact path="/" element={<Rootroute />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/home" element={<HomePage date={date} />} />
                    <Route path="/changepass" element={<ResetPass />} />
                    <Route path="/unauthorize" element={<Not_Authorize />} />
                    <Route path="/charts" element={<Charts />} />
                    <Route path="*" element={<Error />} />
                </Routes>
            </BrowserRouter>

        </div>
    )
}

export default App